import { supabase } from "@/integrations/supabase/client";

export type PublicSellerSocials = {
  twitter?: string | null;
  instagram?: string | null;
  facebook?: string | null;
  youtube?: string | null;
  tiktok?: string | null;
  discord?: string | null;
};

export type PublicSeller = {
  id: string;
  username: string | null;
  display_name: string | null;
  shop_name: string | null;
  avatar_url: string | null;
  cover_image_url: string | null;
  bio: string | null;
  location: string | null;
  website_url: string | null;
  social_links: PublicSellerSocials | null;
  seller_rating: number | null;
  seller_sales_count: number | null;
  seller_rating_count: number | null;
  seller_positive_pct: number | null;
  seller_profile_enabled: boolean;
  joined_at: string | null;
  is_verified_seller: boolean;
  is_top_seller?: boolean;
};

const COLS =
  "id,username,display_name,shop_name,avatar_url,cover_image_url,bio,location,website_url,social_links,seller_rating,seller_sales_count,seller_rating_count,seller_positive_pct,seller_profile_enabled,joined_at,is_verified_seller,is_top_seller";


const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Fetch a seller by UUID *or* case-insensitive username. */
export async function fetchPublicSeller(handle: string): Promise<PublicSeller | null> {
  const isUuid = UUID_RE.test(handle);
  const query = supabase.from("public_sellers" as never).select(COLS).limit(1);
  const { data, error } = isUuid
    ? await query.eq("id", handle).maybeSingle()
    : await query.ilike("username", handle.trim().toLowerCase()).maybeSingle();
  if (error) throw error;
  return (data as PublicSeller | null) ?? null;
}

export async function fetchPublicSellersByIds(ids: string[]): Promise<Map<string, PublicSeller>> {
  const unique = Array.from(new Set(ids.filter(Boolean)));
  if (unique.length === 0) return new Map();
  const { data, error } = await supabase
    .from("public_sellers" as never)
    .select(COLS)
    .in("id", unique);
  if (error) throw error;
  const map = new Map<string, PublicSeller>();
  for (const row of (data ?? []) as PublicSeller[]) map.set(row.id, row);
  return map;
}
